(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ab-contact"]) return;
  try {
    
const abTopic = new URLSearchParams(window.location.search).get('topic');
const abMessage = document.getElementById('ab-message');
if (abTopic && abMessage && !abMessage.value) abMessage.value = abTopic.slice(0,200) + '\n\n';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ab-quiz"]) return;
  try {
    
if (!customElements.get('abhyas-quiz')) {
 customElements.define('abhyas-quiz', class extends HTMLElement {
  connectedCallback() {
   if (this.ready) return;
   this.ready = true;
   const form = this.querySelector('form');
   const fields = [...this.querySelectorAll('fieldset')];
   const result = this.querySelector('.ab-quiz-result');
   form.addEventListener('submit', event => {
    event.preventDefault();
    let score = 0;
    fields.forEach(field => {
     const selected = field.querySelector('input:checked');
     const correct = selected && selected.value === field.dataset.answer;
     score += correct ? 1 : 0;
     field.querySelector('[data-verdict]').textContent = correct ? this.dataset.correct : this.dataset.incorrect;
     field.querySelector('.ab-quiz-feedback').hidden = false;
     field.classList.toggle('ab-quiz-correct', correct);
     field.classList.toggle('ab-quiz-incorrect', !correct);
     field.querySelectorAll('input').forEach(input => input.disabled = true);
    });
    result.textContent = this.dataset.result.replace('__SCORE__', score).replace('__TOTAL__', fields.length);
    result.hidden = false;
    form.querySelector('[type="submit"]').disabled = true;
    result.focus();
   });
   form.addEventListener('reset', () => {
    fields.forEach(field => {
     field.classList.remove('ab-quiz-correct', 'ab-quiz-incorrect');
     field.querySelector('.ab-quiz-feedback').hidden = true;
     field.querySelectorAll('input').forEach(input => input.disabled = false);
    });
    result.hidden = true;
    form.querySelector('[type="submit"]').disabled = false;
   });
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
